
import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './styles/critical.css' // Load critical CSS first
import './styles/index.css'
import './App.css'; // This will import all the refactored CSS files through App.css
import { BrowserRouter } from 'react-router-dom'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
)
